import { useContext, useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import avatar from "../../../icons/avatar.jpg";
import close from "../../../icons/close.svg";

import { BiSearch } from "react-icons/bi";
import { AiOutlineClose } from "react-icons/ai";
import "../../../styles/modals.scss";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import { KycManager } from "../../../context-api/KycContext";
import { variableManager } from "../../../context-api/VariableContex";
import { Spinner } from "react-bootstrap";
import axiosInstance from "../../../utils/axios_instance";
export default function Beneficiaries(props) {
  const [userName, setUsername] = useState("");
  const [modalShowPayNow, setModalShowPayNow] = useState(false);
  const {
    setRerender,
    showBill,
    setShowBill,
    handleBillStatusChange,
    initPayModal,
    profile,
    setProfile,
  } = useContext(KycManager);
  const {
    url,
    msg,
    setMsg,
    user,
    nameCase,
    mongoroReceiver,
    setMongoroReceiver,
    setwalletTag,
    accountDetails,
    setAccountDetails,
    handleDeleteBeneficiary,
  } = useContext(variableManager);

  const [bankBeneficiaries, setBankBeneficiaries] = useState([]);
  const [mongoroBeneficiaries, setMongoroBeneficiaries] = useState([]);
  const [clicked, setClicked] = useState({
    id: "",
    search: "",
  });

  const [searchResult, setSearchResult] = useState("");

  useEffect(() => {
    // handleGetBeneficiaries();
  }, [user]);

 
  async function handleGetBeneficiaries() {
    try {
      const list = await axiosInstance.get(`/business/beneficiary/user`);
      const data = list.data.data;
      setBankBeneficiaries(data.bankBeneficiary);
      setMongoroBeneficiaries(data.mongoroBeneficiary);
    } catch (error) {
      console.log(error);
    }
  }

  function searchData(data, query) {
    let result;
    if (showBill.airtime) {
      result = data.filter((a) => {
        if (
          a.beneficiaryName.toLowerCase().includes(query) ||
          a.walletTag.includes(query)
        ) {
          return a;
        } else {
          return false;
        }
      });
    } else {
      result = data.filter((a) => {
        if (
          a.beneficiaryName.toLowerCase().includes(query) ||
          a.bankName.toLowerCase().includes(query) ||
          a.accountNumber.includes(query)
        ) {
          return a;
        } else {
          return false;
        }
      });
    }

    if (result.length) {
      return result;
    } else {
      return [{ beneficiaryName: "No results found" }];
    }
  } 
  return (
    <div className="sendpayment">
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        scrollable
      >
        {/* <Modal.Header>
          <div
            className="modal-header pointer"
            onClick={() => {
              handleBillStatusChange("switchOff");
            }}
          >
            <img draggable="false" src={close} alt="close" />
          </div>
        </Modal.Header> */}

        <Modal.Body className="modalContent" style={{ height: "100vh" }}>
          <div className="input-area">
            <div className="choose-contact">
              <div className="head mb-4">
                <BsChevronLeft
                  className="pointer"
                  onClick={() => {
                    handleBillStatusChange("switchOff");

                    // if(showBill.actionFrom.airtime){
                    //   handleBillStatusChange("airtime", "details")
                    // }else if (showBill.actionFrom.cableTv){
                    //   handleBillStatusChange("cableTv", "details")
                    // }
                  }}
                />
                <h5>Choose a Beneficiary</h5>
                <div className="search">
                  <BiSearch
                    onClick={() => setClicked({ ...clicked, search: true })}
                  />
                  {clicked.search && (
                    <div className="box">
                      <AiOutlineClose
                        className="mo-danger pointer"
                        onClick={() => {
                          setClicked({ ...clicked, search: false });
                          setSearchResult("");
                        }}
                      />
                      <input
                        type="search"
                        autoFocus
                        placeholder="find beneficiary"
                        onChange={(e) => {
                          if (showBill.airtime) {
                            setSearchResult(
                              searchData(mongoroBeneficiaries, e.target.value)
                            );
                          } else {
                            setSearchResult(
                              searchData(bankBeneficiaries, e.target.value)
                            );
                          }
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>

              {showBill.airtime.details &&
              !searchResult &&
              mongoroBeneficiaries.length ? (
                mongoroBeneficiaries.map((e, i) => {
                  return (
                    <div
                      className="contact"
                      onClick={() => {
                        setMongoroReceiver({
                          ...mongoroReceiver,
                          walletTag: e.walletTag,
                        });
                        setwalletTag(e.beneficiaryName);
                        setShowBill({
                          ...initPayModal,
                          airtime: true,
                        });
                      }}
                      key={i}
                    >
                      <div className="details pointer">
                        <div className="image">
                          {e.image && (
                            <img src={e.image} alt={e.beneficiaryName} />
                          )}
                        </div>
                        <div className="names">
                          <p className="first">{nameCase(e.beneficiaryName)}</p>
                          <p>@{e.walletTag}</p>
                          {/* <p>{e.accountNumber}</p> */}
                          <input type="hidden" value={e.accountBank} />
                        </div>
                      </div>

                      <div
                        className="right"
                        onClick={(event) => {
                          setClicked({ ...clicked, id: e.beid });
                          event.stopPropagation();
                          setProfile({
                            ...profile,
                            deletePrompt: {
                              ...profile.deletePrompt,
                              beneficiary: true,
                              beneficiaryId: e.beid,
                            },
                          });
                        }}
                      >
                        {/* <BsChevronRight /> */}

                        {msg.spinner && e.beid === clicked.id ? (
                          <Spinner size="sm" variant="warning" />
                        ) : (
                          <AiOutlineClose className="mo-danger pointer" />
                        )}
                      </div>
                    </div>
                  );
                })
              ) : showBill.airtime.details &&
                searchResult &&
                searchResult.length ? (
                searchResult.map((e, i) => {
                  return (
                    <div
                      className="contact"
                      onClick={() => {
                        setMongoroReceiver({
                          ...mongoroReceiver,
                          walletTag: e.walletTag,
                        });
                        setwalletTag(e.beneficiaryName);
                        setShowBill({
                          ...initPayModal,
                          airtime: true,
                        });
                      }}
                      key={i}
                    >
                      <div className="details pointer">
                        <div className="image">
                          {e.image && (
                            <img src={e.image} alt={e.beneficiaryName} />
                          )}
                        </div>
                        <div className="names">
                          <p className="first">{nameCase(e.beneficiaryName)}</p>
                          <p>{e.walletTag}</p>
                          {/* <p>{e.accountNumber}</p> */}
                          <input type="hidden" value={e.accountBank} />
                        </div>
                      </div>

                      <div
                        className="right"
                        onClick={(event) => {
                          setClicked({ ...clicked, id: e.beid });
                          event.stopPropagation();
                          setProfile({
                            ...profile,
                            deletePrompt: {
                              ...profile.deletePrompt,
                              beneficiary: true,
                              beneficiaryId: e.beid,
                            },
                          });
                        }}
                      >
                        {/* <BsChevronRight /> */}
                        {msg.spinner && e.beid === clicked.id ? (
                          <Spinner size="sm" variant="warning" />
                        ) : (
                          e._id && (
                            <AiOutlineClose className="mo-danger pointer" />
                          )
                        )}
                      </div>
                    </div>
                  );
                })
              ) : showBill.airtime.details &&
                !searchResult &&
                !mongoroBeneficiaries.length ? (
                <p>
                  You have no saved beneficiaries yet, transact now to
                  save beneficiaries


                  <br />
                   
                    <span 
                    onClick={() =>
                      handleBillStatusChange("global", "deletePrompt")
                    }
                    
                    className="text-danger fw-bolder pointer">DELETE Airtime BENEFICIARY</span>
                </p>
              ) : null}

              {!showBill.airtime.details ? (
                showBill.cableTv.details &&
                !searchResult &&
                bankBeneficiaries.length ? (
                  bankBeneficiaries.map((e, i) => {
                    return (
                      <div className="contact" key={i}>
                        <div
                          className="details pointer"
                          onClick={() => {
                            setAccountDetails({
                              ...accountDetails,
                              accountNumber: e.accountNumber,
                              accountBank: e.accountBank,
                              accountName: e.beneficiaryName,
                              bankName: e.bankName,
                            });
                            setShowBill({
                              ...showBill,
                              chooseContact: false,
                            });
                          }}
                        >
                          {/* <div className="image">
                            <img src={avatar} alt="contact" />
                          </div> */}
                          <div className="names">
                            <p className="first">
                              {nameCase(e.beneficiaryName)}
                            </p>
                            <p>{e.bankName ? e.bankName : null}</p>
                            <p>{e.accountNumber}</p>
                            {/* <p>{e.accountNumber}</p> */}
                            <input type="hidden" value={e.accountBank} />
                          </div>
                        </div>

                        <div
                          className="right"
                          onClick={(event) => {
                            setClicked({ ...clicked, id: e.beid });
                            event.stopPropagation();
                            setProfile({
                              ...profile,
                              deletePrompt: {
                                ...profile.deletePrompt,
                                beneficiary: true,
                                beneficiaryId: e.beid,
                              },
                            });
                          }}
                        >
                          {/* <BsChevronRight /> */}
                          {msg.spinner && e.beid === clicked.id ? (
                            <Spinner size="sm" variant="warning" />
                          ) : (
                            <AiOutlineClose className="mo-danger pointer" />
                          )}
                        </div>
                      </div>
                    );
                  })
                ) : showBill.cableTv.details &&
                  searchResult &&
                  searchResult.length ? (
                  searchResult.map((e, i) => {
                    return (
                      <div className="contact" key={i}>
                        <div
                          className="details pointer"
                          onClick={() => {
                            setAccountDetails({
                              ...accountDetails,
                              accountNumber: e.accountNumber,
                              accountBank: e.accountBank,
                              accountName: e.beneficiaryName,
                              bankName: e.bankName,
                            });
                            setShowBill({
                              ...showBill,
                              chooseContact: false,
                            });
                          }}
                        >
                          {/* <div className="image">
                            <img src={avatar} alt="contact" />
                          </div> */}
                          <div className="names">
                            <p className="first">
                              {nameCase(e.beneficiaryName)}
                            </p>
                            <p>{e.bankName ? e.bankName : null}</p>
                            <p>{e.accountNumber}</p>
                            {/* <p>{e.accountNumber}</p> */}
                            <input type="hidden" value={e.accountBank} />
                          </div>
                        </div>

                        <div
                          className="right"
                          onClick={(event) => {
                            setClicked({ ...clicked, id: e.beid });
                            event.stopPropagation();
                            setProfile({
                              ...profile,
                              deletePrompt: {
                                ...profile.deletePrompt,
                                beneficiary: true,
                                beneficiaryId: e.beid,
                              },
                            });
                          }}
                        >
                          {/* <BsChevronRight /> */}
                          {msg.spinner && e.beid === clicked.id ? (
                            <Spinner size="sm" variant="warning" />
                          ) : (
                            <AiOutlineClose className="mo-danger pointer" />
                          )}
                        </div>
                      </div>
                    );
                  })
                ) : showBill.cableTv.details &&
                  !searchResult &&
                  !bankBeneficiaries.length ? (
                  <p>
                    You have no saved beneficiaries yet, transact now to
                    save beneficiaries


                   <br />
                   
                    <span 
                    onClick={() =>
                      handleBillStatusChange("global", "deletePrompt")
                    }
                    
                    className="text-danger fw-bolder pointer">DELETE Cable BENEFICIARY</span>
                  </p>
                ) : null
              ) : null}



{showBill.electricity.details &&
              !searchResult &&
              mongoroBeneficiaries.length ? (
                mongoroBeneficiaries.map((e, i) => {
                  return (
                    <div
                      className="contact"
                      onClick={() => {
                        setMongoroReceiver({
                          ...mongoroReceiver,
                          walletTag: e.walletTag,
                        });
                        setwalletTag(e.beneficiaryName);
                        setShowBill({
                          ...initPayModal,
                          airtime: true,
                        });
                      }}
                      key={i}
                    >
                      <div className="details pointer">
                        <div className="image">
                          {e.image && (
                            <img src={e.image} alt={e.beneficiaryName} />
                          )}
                        </div>
                        <div className="names">
                          <p className="first">{nameCase(e.beneficiaryName)}</p>
                          <p>@{e.walletTag}</p>
                          {/* <p>{e.accountNumber}</p> */}
                          <input type="hidden" value={e.accountBank} />
                        </div>
                      </div>

                      <div
                        className="right"
                        onClick={(event) => {
                          setClicked({ ...clicked, id: e.beid });
                          event.stopPropagation();
                          setProfile({
                            ...profile,
                            deletePrompt: {
                              ...profile.deletePrompt,
                              beneficiary: true,
                              beneficiaryId: e.beid,
                            },
                          });
                        }}
                      >
                        {/* <BsChevronRight /> */}

                        {msg.spinner && e.beid === clicked.id ? (
                          <Spinner size="sm" variant="warning" />
                        ) : (
                          <AiOutlineClose className="mo-danger pointer" />
                        )}
                      </div>
                    </div>
                  );
                })
              ) : showBill.electricity.details &&
                searchResult &&
                searchResult.length ? (
                searchResult.map((e, i) => {
                  return (
                    <div
                      className="contact"
                      onClick={() => {
                        setMongoroReceiver({
                          ...mongoroReceiver,
                          walletTag: e.walletTag,
                        });
                        setwalletTag(e.beneficiaryName);
                        setShowBill({
                          ...initPayModal,
                          airtime: true,
                        });
                      }}
                      key={i}
                    >
                      <div className="details pointer">
                        <div className="image">
                          {e.image && (
                            <img src={e.image} alt={e.beneficiaryName} />
                          )}
                        </div>
                        <div className="names">
                          <p className="first">{nameCase(e.beneficiaryName)}</p>
                          <p>{e.walletTag}</p>
                          {/* <p>{e.accountNumber}</p> */}
                          <input type="hidden" value={e.accountBank} />
                        </div>
                      </div>

                      <div
                        className="right"
                        onClick={(event) => {
                          setClicked({ ...clicked, id: e.beid });
                          event.stopPropagation();
                          setProfile({
                            ...profile,
                            deletePrompt: {
                              ...profile.deletePrompt,
                              beneficiary: true,
                              beneficiaryId: e.beid,
                            },
                          });
                        }}
                      >
                        {/* <BsChevronRight /> */}
                        {msg.spinner && e.beid === clicked.id ? (
                          <Spinner size="sm" variant="warning" />
                        ) : (
                          e._id && (
                            <AiOutlineClose className="mo-danger pointer" />
                          )
                        )}
                      </div>
                    </div>
                  );
                })
              ) : showBill.electricity.details &&
                !searchResult &&
                !mongoroBeneficiaries.length ? (
                <p>
                  You have no saved beneficiaries yet, transact now to
                  save beneficiaries


                  <br />
                   
                    <span 
                    onClick={() =>
                      handleBillStatusChange("global", "deletePrompt")
                    }
                    
                    className="text-danger fw-bolder pointer">DELETE Electricity BENEFICIARY</span>
                </p>
              ) : null}
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* <div className="modal">
                <PayNow
                show={showBill.payNow}
                onHide={()=> setShowBill({...initPayModal, payNow:false})}
                />
            </div> */}
    </div>
  );
}
